import { render, staticRenderFns } from "./FS_two_column_text.vue?vue&type=template&id=9e8e6978&"
import script from "./FS_two_column_text.vue?vue&type=script&lang=js&"
export * from "./FS_two_column_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports